import type { Home } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';

import DictionaryEditor from '../dictionary-editor.gts';

interface Signature {
  Args: {
    home: Home;
    uniqueId: string;
    isReadOnly: boolean;
  };
}

const DEV_MAPPER_KEYS = [
  {
    key: 'devMapperLink',
    label: 'Development mapper link',
    placeholder: '(link to mapper)',
  },
  {
    key: 'devMapperTitle',
    label: 'Development mapper heading',
    placeholder: 'Development mapper',
  },
  {
    key: 'devMapperIntro',
    label: 'Not completed message',
    placeholder:
      'The objective of the Development Mapper is to help you identify your key development needs in relation to critical behaviours you wish to develop.',
  },
  {
    key: 'devMapperExplanation',
    label: 'Completed message',
    placeholder:
      'The visual below provides an overview of your key development areas. It compares what you have identified as the most important development themes with your ratings of capability aligned to our core topic areas.',
  },
  {
    key: 'devMapperLaunch',
    label: 'Launch quiz button text',
    placeholder: 'Identify development needs',
  },
  {
    key: 'devMapperResults',
    label: 'Results button text',
    placeholder: 'View full results',
  },
];

class HomeSection extends Component<Signature> {
  get isReadOnly() {
    return this.args.isReadOnly;
  }

  <template>
    <h3 class="mb-4">Client Home</h3>

    <fieldset class="mb-5" disabled={{this.isReadOnly}}>
      <legend class="gud-eyebrow">Development Mapper</legend>
      <p class="text-muted">
        Curate the copy and linked quizzes shown in the client home "Development
        mapper" cards.
      </p>

      <DictionaryEditor
        @item={{@home}}
        @keys={{DEV_MAPPER_KEYS}}
        @isReadOnly={{this.isReadOnly}}
      />
    </fieldset>
  </template>
}

export default HomeSection;
